<template lang="pug">
  .root
    the-heading(:caption="'Новая учетная запись'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Новая учетная запись
        .fields
          .item
            label Имя *
            .field_container
              WebiomedInput(v-model="filter.first_name" :error="errors.first_name")
          .item
            label Фамилия *
            .field_container
              WebiomedInput(v-model="filter.last_name" :error="errors.last_name")
          .item
            label Отчество
            .field_container
              WebiomedInput(v-model="filter.second_name" :error="errors.second_name")
          .item
            label Электронная почта
            .field_container
              WebiomedInput(v-model="filter.email" :error="errors.email")
          .item
            label Имя учётной записи *
            .field_container
              WebiomedInput(v-model="filter.username" :error="errors.username")
          .item
            label Пароль *
            .field_container
              WebiomedInput(v-model="filter.password" :type="'password'" :error="errors.password")
          .item
            label Группа доступа *
            .field_container
              WebiomedSelect(:options="options" v-model="filter.group" :error="errors.group")
          .item
            label Регион
            .field_container
              WebiomedSearchField(
              v-model="filter.region"
              :value="filter.region"
              :search_by="'id'"
              :show="'formalname'"
              :additional_name="'shortname'"
              :address="'nsi/values/sys-fias-entities/?aolevel=1&formalname__icontains='"
              :placeholder="'Введите регион...'"
              :icons="'globe'"
              )
          .item
            label Название МО
            .field_container
              WebiomedInput(v-model="filter.hospital_name")
        .radio
          .item
            input(type="checkbox" id="is_active" v-model="filter.has_frontend_access")
            label(for="is_active") Имеет доступ к пользовательскому интерфейсу
          .item
            input(type="checkbox" id="is_ai_used" v-model="filter.is_ai_used")
            label(for="is_ai_used") Имеет доступ к рекомендациям в результатах запросов
          .item
            input(type="checkbox" id="is_extended_subscription" v-model="filter.is_extended_subscription")
            label(for="is_extended_subscription") Использовать расчет рисков на основе нейросети
          .item
            input(type="checkbox" id="is_nlp_used" v-model="filter.is_nlp_used")
            label(for="is_nlp_used") Включить извлечение признаков с помощью NLP
    ButtonsPanel(:save="true" :closeWithOutChanges="true")

</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import ButtonsPanel from '@/components/parts/ButtonsPanel'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import breadcrumbs from '@/data/breadcrumbs/UserAdd'
import options from '@/data/options/permissionGroups'
import axios from 'axios'

export default {
  components: {
    TheHeading,
    ButtonsPanel,
    WebiomedInput,
    WebiomedSelect,
    WebiomedSearchField
  },
  data () {
    return {
      breadcrumbs,
      filter: {},
      options,
      errors: {}
    }
  },
  methods: {
    saveState () {
      axios.post('dhra/api/v2/system/users/register/', this.filter).then(
        values => {
          this.$notify({
            text: 'Учётная запись была успешно создана',
            type: 'sucsess'
          })
          this.$router.go(-1)
        },
        errors => {
          this.errors = errors.response.data
          this.$notify({
            text: 'ошибка',
            type: 'warn'
          })
        }
      )
    },
    closeState () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/ChangeStateStyles.sass"
.item label
  cursor: pointer
.item label:hover
  color: #404040
.item input
  cursor: pointer
</style>
